export default "__VITE_ASSET__rDrjhGk$__"